import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "emailInput", "submitButton", "message", "referrerInput"]
  static values = { url: String }

  async submit(event) {
    event.preventDefault();

    const email = this.emailInputTarget.value.trim();
    if (!email) return;

    // 현재 페이지 URL을 referrer_url에 설정
    if (this.hasReferrerInputTarget) {
      this.referrerInputTarget.value = window.location.href;
    }

    this.submitButtonTarget.disabled = true;
    const originalText = this.submitButtonTarget.textContent;
    this.submitButtonTarget.textContent = "...";

    try {
      const formData = new FormData(this.formTarget);
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        // Replace form with success message
        this.formTarget.innerHTML = `
          <p style="font-size: 15px; font-weight: 500; color: #059669; margin: 0;">
            구독해주셔서 감사합니다! 🎉
          </p>
        `;
      } else {
        // Show error
        this._showError("구독 처리 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.");
        this.submitButtonTarget.disabled = false;
        this.submitButtonTarget.textContent = originalText;
      }
    } catch (e) {
      this._showError("네트워크 오류가 발생했습니다.");
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.textContent = originalText;
    }
  }

  _showError(msg) {
    this.messageTarget.textContent = msg;
    this.messageTarget.style.display = "block";
    this.messageTarget.style.color = "#dc2626";
  }
}
